import { IFlightPairingStatus, IFlightPairingStatusMap } from "@vmosolutions/oc-interfaces";
import { returnFlightPairingStatus } from "src/pages/FlightPairingStatus/helpers";

import moment from "moment-timezone";

export enum Type {
  SET_FLIGHT_PAIRING_STATUS = "SET_FLIGHT_PAIRING_STATUS",
  SET_FLIGHT_PAIRING_STATUS_MAP = "SET_FLIGHT_PAIRING_STATUS_MAP",
}

export interface ISetFlightPairingStatus {
  type: Type.SET_FLIGHT_PAIRING_STATUS;
  selectedFlightStatus: IFlightPairingStatus;
}
export interface ISetFlightPairingStatusMap {
  type: Type.SET_FLIGHT_PAIRING_STATUS_MAP;
  flightStatusMap: IFlightPairingStatusMap;
}

export type Action = ISetFlightPairingStatus | ISetFlightPairingStatusMap;

export const setSelectedFlightPairingStatus = (selectedFlightStatus: IFlightPairingStatus): ISetFlightPairingStatus => {
  if (!selectedFlightStatus) return null;
  return { type: Type.SET_FLIGHT_PAIRING_STATUS, selectedFlightStatus };
};

const returnFlightPairingShortCodes = (currentValue: IFlightPairingStatus): string[] => {
  const { actualCrew } = currentValue;
  const shortCodes = actualCrew ? actualCrew.map((crew) => crew.prgCode) : [];
  return Array.from(new Set([...shortCodes]));
};

// Creates a hashmap of the flight status objects and stores them in redux.
// This makes it easier for us to update them using websockets later if we so desire.
export const setPairingStatusMap = (data: IFlightPairingStatus[]): ISetFlightPairingStatusMap => {
  if (!data || data.length === 0) return null;
  // Use moment to determine how many days
  const flightStatusMap = data.reduce((acc: { [key: string]: any }, currentValue) => {
    // All row content must have matching flight numbers, origin and destinations.
    const key = `${currentValue.flightNumber}|${currentValue.origin}|${currentValue.destination}`;
    const date = moment(currentValue.actualOut).utc().format("YYYY-MM-DD");
    // Set the status value;
    currentValue.pairingShortCodes = returnFlightPairingShortCodes(currentValue);
    currentValue.pairingStatuses = returnFlightPairingStatus(currentValue);
    if (acc[key]) {
      if (acc[key][date]) {
        // console.log("this row's date contains more than 1 flight");
        acc[key][date].push(currentValue);
      } else {
        acc[key][date] = [currentValue];
      }
    } else {
      acc[key] = { [date]: [currentValue] };
    }
    return acc;
  }, {});
  // console.log(flightStatusMap);
  return { type: Type.SET_FLIGHT_PAIRING_STATUS_MAP, flightStatusMap };
};
